import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import { DeliveryMethod } from '@/pages/LogisticsManage/LogisticsPath/service';
import { DayTypeEnum } from '../type';

const model = {
  state: {
    businessDistrictList: [],
    distributionUnitId: null,
    meatTimeList: [], // 商圈餐段
    routeTabelParams: {
      pageSize: 10,
      page: 1,
    }, // 线路tabel参数
    routeParams: {
      distributionUnitId: null,
      dispatchRouteId: null,
      transferStationId: null,
    }, // 筛选项
    modalVisible: false,
    timeIntervalId: null, // 当前班次
    routeList: [], // 线路表格
    currentRoute: {}, // 当前选中线路
    selectRoute: {}, // 要调整到的线路
    routeCompanyData: [], // 线路企业
    currentCheckCompany: [], // 当前要调整的企业线路
    rebuildClickFlag: false, // 重置线路按钮是否可以点击
    routeListTotal: 0, // 线路总数
    allRouteList: [], // 总线路数组
    nonAddressNum: 0, // 无线路取餐点数量
    currentMeatTime: {},
    businessDistrict: {},
    deliveryMethod: DeliveryMethod.Direct.value,
    dayType: DayTypeEnum.WorkDay,
    unitList: [],
    intervalList: [],
    intervalMap: new Map(),
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { basic, logisticsPath }, getState }) => ({
    setDeliveryMethod(method) {
      logisticsPath.setState({
        deliveryMethod: method,
      });
    },
    setDayType(dayType) {
      logisticsPath.setState({
        dayType,
      });
    },
    /**
     * 配送单元下拉
     * @param {*} params
     * @param {*} config 默认值
     */
    async getUnitList(params, config) {
      if (!params) {
        logisticsPath.setState({ unitList: [] });
        return [];
      }
      const data = await fetch('/saasmerchant/fsarea/distribution/unit/base/authority/sortList', {
        params,
      });
      if (data?.list) {
        const unitList = data?.list?.map((item) => {
          const { distributionUnitName, distributionUnitId } = item;
          return {
            label: distributionUnitName,
            value: distributionUnitId,
            key: distributionUnitId,
            ...item,
          };
        });
        logisticsPath.setState({ unitList });
        // 默认选择第一项
        logisticsPath.setDistributionUnitInfo(
          Number(config?.distributionUnitId) || unitList[0]?.value,
        );
        config?.deliveryMethod && logisticsPath.setDeliveryMethod(Number(config?.deliveryMethod));
        return unitList;
      }
    },
    /**
     * 获取班次 餐段
     * @param {*} param
     */
    async getIntervalList() {
      const intervalMap = new Map();
      const data = await fetch('/saasmerchant/fsarea/distribution/unit/time/interval/list', {
        params: {
          distributionUnitId: getState().logisticsPath.distributionUnitId,
        },
      });

      if (data) {
        const intervalList = data?.map((item) => {
          const { beginTime, endTime, timeIntervalId, detail } = item;
          const detailCn = detail
            ?.map((item) => {
              return item?.cbdName + '-' + item?.mealTimeName;
            })
            .join('、');
          intervalMap.set(timeIntervalId, detailCn);
          return {
            label: beginTime + '-' + endTime,
            value: timeIntervalId,
            key: timeIntervalId,
            ...item,
          };
        });
        // 默认选择第一项
        logisticsPath.setIntervalInfo(intervalList[0] || {});
        // 线路列表设置为空
        logisticsPath.setState({
          intervalList,
          intervalMap,
          routeList: [],
          routeListTotal: 0,
          nonAddressNum: 0,
        });
        return intervalList;
      }
    },
    setBussinessFilter(param) {
      logisticsPath.setState({
        routeParams: {
          ...param,
        },
      });
      logisticsPath.getRouteList();
    },
    // // 选择商圈
    // setBusinessDistrict(id) {
    //   logisticsPath.setState({ distributionUnitId: id });
    // },
    // setBusinessDistrictInfo(business) {
    //   logisticsPath.setState({
    //     distributionUnitId: business.value,
    //     businessDistrict: {
    //       id: business.value,
    //       name: business.name,
    //     },
    //   });
    // },
    setDistributionUnitInfo(id) {
      logisticsPath.setState({
        distributionUnitId: id,
      });
    },
    // 重置筛选项
    onReset() {
      logisticsPath.setState({
        routeParams: {
          distributionUnitId: null,
          dispatchRouteId: null,
          transferStationId: null,
        },
      });
    },
    onRouteReset() {
      logisticsPath.setState({
        routeTabelParams: {
          pageSize: 10,
          page: 1,
        },
      });
    },
    // // 餐段
    // async getMealTimeList() {
    //   const params = {
    //     distributionUnitId: getState().logisticsPath.distributionUnitId,
    //   };
    //   const data = await fetch('/saasmerchant/fsarea/mealTime/queryBdMealTimes', {
    //     type: 'POST',
    //     params,
    //     useJson: true,
    //   });
    //   logisticsPath.setState({
    //     meatTimeList: data,
    //   });
    //   if (data && data.length > 0) {
    //     logisticsPath.setState({
    //       timeIntervalId: data[0].timeIntervalId,
    //       currentMeatTime: {
    //         id: data[0].timeIntervalId,
    //         name: data[0].mealTimeName,
    //       },
    //     });
    //   } else {
    //     logisticsPath.setState({
    //       timeIntervalId: null,
    //       currentMeatTime: {},
    //     });
    //   }
    // },
    // 获取线路列表
    async getRouteList(param = {}, rebuildClickFlag = false) {
      const {
        distributionUnitId,
        timeIntervalId,
        routeParams,
        routeTabelParams,
        deliveryMethod,
        dayType,
      } = getState().logisticsPath;
      const params = filterNull({
        ...routeParams,
        ...routeTabelParams,
        distributionUnitId: distributionUnitId,
        timeIntervalId: timeIntervalId,
        deliveryMethod,
        dayType,
        ...param,
      });
      logisticsPath.setState({
        routeListLoading: true,
      });
      const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/list', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        const routeList = data.list || [];
        logisticsPath.setState({
          nonAddressNum: data.nonAddressNum,
          routeList: [...routeList],
          routeListTotal: data.total,
        });
      }
      logisticsPath.setState({
        routeListLoading: false,
      });
      if (rebuildClickFlag) {
        logisticsPath.setState({
          rebuildClickFlag: false,
        });
      }
    },
    // setRouteShowType
    setRouteShowType(row) {
      const { routeList } = getState().logisticsPath;
      routeList.forEach((route) => {
        if (route?.dispatchRouteId === row?.dispatchRouteId) {
          route.showType = !route.showType;
        }
      });
      logisticsPath.setState({
        routeList: [...routeList],
      });
    },
    // 导出线路
    async exportRouteList(param) {
      logisticsPath.setState({
        routeParams: {
          ...param,
        },
      });
      const { distributionUnitId, timeIntervalId, deliveryMethod, dayType } =
        getState().logisticsPath;
      const params = filterNull({
        ...param,
        distributionUnitId,
        timeIntervalId,
        deliveryMethod,
        dayType,
      });
      // page	number
      // pageSize	number

      const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/list/export', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('导出成功');
        basic.setLogListDot(true);
      }
    },
    setCurrentRoute(route) {
      logisticsPath.setState({
        currentRoute: route,
      });
      logisticsPath.searchRoute(route.dispatchRouteId);
    },
    // settimeIntervalId(meatId) {
    //   logisticsPath.setState({
    //     timeIntervalId: meatId,
    //   });
    // },
    // setCurrentMeatTime(meal) {
    //   logisticsPath.setState({
    //     timeIntervalId: meal.value,
    //     currentMeatTime: meal,
    //   });
    // },
    setIntervalInfo(timeInfo) {
      logisticsPath.setState({
        timeIntervalId: timeInfo.value,
        // currentMeatTime: {
        //   id: meal.value,
        //   name: meal.children,
        // },
      });
    },
    async searchRoute(dispatchRouteId, companyName = null, addressType) {
      const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/search', {
        type: 'POST',
        params: filterNull({
          dispatchRouteId,
          companyName,
          addressType,
        }),
        useJson: true,
      });
      logisticsPath.setState({
        routeCompanyData: data.map((company) => {
          return {
            title: company.companyName,
            value: company.companyId,
            key: company.companyId,
            children: company.addrs.map((addr) => {
              return {
                title: addr.address,
                value: addr.addrId,
                key: addr.addrId,
              };
            }),
          };
        }),
      });
    },
    setSelectRoute(route) {
      logisticsPath.setState({
        selectRoute: route,
      });
    },
    handleCompanyChange(company) {
      logisticsPath.setState({
        currentCheckCompany: company,
      });
    },
    resetRouteCompanyData() {
      logisticsPath.setState({
        routeCompanyData: [],
        currentCheckCompany: [],
      });
    },
    setModalVisible(flag) {
      logisticsPath.setState({
        modalVisible: flag,
      });
    },
    async modifyRoute(dispatchParams) {
      const { dispatchRouteName, dispatchRouteSimpleName, inRouteAddrIds } = dispatchParams;
      const { currentRoute, selectRoute, currentCheckCompany, deliveryMethod, distributionUnitId } =
        getState().logisticsPath;

      if (!selectRoute) {
        message.error('请选择要调整到的线路');
        return;
      }
      const curRouteAddrIds = currentCheckCompany.map((route) => {
        return route.value;
      });
      const params = filterNull({
        dispatchRouteId: currentRoute.dispatchRouteId,
        dispatchRouteName,
        dispatchRouteSimpleName,
        targetRouteId: selectRoute.dispatchRouteId || null,
        targetRouteName: selectRoute.dispatchRouteId ? null : selectRoute.dispatchRouteName,
        inRouteAddrIds,
        outRouteAddrIds: curRouteAddrIds,
        deliveryMethod,
        distributionUnitId: distributionUnitId,
      });
      const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/modify', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('调整成功');
        logisticsPath.setModalVisible(false);
        logisticsPath.getRouteList();
      }
    },
    setFilter(params) {
      logisticsPath.setState({
        routeTabelParams: { ...getState().logisticsPath.routeTabelParams, ...params },
      });
    },
    // 翻页
    onNav(page) {
      logisticsPath.setState({
        routeTabelParams: {
          page,
        },
      });
      logisticsPath.getRouteList();
    },
    // 重置线路
    async rebuildRoute() {
      const { distributionUnitId, timeIntervalId, deliveryMethod, dayType } =
        getState().logisticsPath;
      logisticsPath.setState({
        rebuildClickFlag: true,
      });
      const data = await fetch('/saasmerchant/fsarea/distribution/unit/dispatchroute/rebuild', {
        type: 'POST',
        params: {
          distributionUnitId: distributionUnitId,
          timeIntervalId: timeIntervalId,
          deliveryMethod,
          dayType,
        },
        useJson: true,
      });
      if (data) {
        message.success('重置成功，一分钟后生效');
        logisticsPath.getRouteList({}, true);
      } else {
        logisticsPath.setState({
          rebuildClickFlag: false,
        });
        message.error('重置失败');
      }
    },
  }),
};

export default model;
